import { render, staticRenderFns } from "./MultiSelectGroup.vue?vue&type=template&id=283bd85f&scoped=true"
import script from "./MultiSelectGroup.vue?vue&type=script&lang=js"
export * from "./MultiSelectGroup.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectGroup.vue?vue&type=style&index=0&id=283bd85f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bd85f",
  null
  
)

export default component.exports